const logs = {
	title: "Logger",
	details: "Loggdetaljer",
	id: "ID",
	user_id: "Bruker",
	action: "Hendelse",
	action_model: "Hendelsestype",
	action_id: "Hendelses ID",
	record: "Registrering",
	ip_address: "IP adresse",
	created_at: "Dato",
	field: "Felt",
	before_values: "Før verdier",
	after_values: "Etter verdier",
};
export default logs;